import { useFormContext } from 'react-hook-form'
import { CurecallInput } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { PlanningTabFormValues } from '../planning.type'

export default function PlanningTabLabelField() {
  const { t } = useTranslation()
  const {
    register,
    formState: { errors },
  } = useFormContext<PlanningTabFormValues>()

  return (
    <div className="c-flex c-gap-6 c-items-end">
      <CurecallInput
        {...register('label', { required: t('pages.planning.form.required') })}
        label={t('pages.planning.form.tab-name')}
        placeholder={t('pages.planning.form.tab-name-placeholder')}
        isRequired={true}
        tooltipContent={t('pages.planning.form.tab-name-tooltip')}
        tooltipPosition="bottom"
        wrapperClassName="c-w-72"
        errorMessage={errors['label']?.message}
      />
    </div>
  )
}
